<template>
  <v-menu
    :close-on-content-click="false"
    left
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="showBadge"
        :content="count"
        class="white--text"
        color="primary"
      >
        <v-btn v-bind="attrs" v-on="on" color="primary" small outlined>
          <v-icon dense x-small left>fa-sort-amount-down</v-icon>
          Ordenar
        </v-btn>
      </v-badge>
    </template>
    <div class="menu__content">
      <v-list>
        <v-list-item
          v-for="(sort, index) in faturamentoGuiasSorting"
          :key="index"
        >
          <div class="d-flex align-center">
            <v-select
              @change="event => updateSortValue(index, event)"
              :items="sortingColumnsValues"
              :value="sort.value"
              :style="'width: 240px'"
              class="mr-2"
              outlined
              dense
              hide-details
            />
            <v-select
              @change="event => updateSortDirection(index, event)"
              :items="sortingOrderValues"
              :value="sort.direction"
              :style="'width: 150px'"
              class="mr-2"
              outlined
              dense
              hide-details
            />
            <v-btn
              @click="() => removeSort(index)"
              icon
            >
              <v-icon small>fa-times</v-icon>
            </v-btn>
          </div>
        </v-list-item>
      </v-list>
      <v-btn
        @click="addNewSort"
        color="primary"
        class="mx-4 mb-4"
      >
        <v-icon left small>fa-plus</v-icon>
        Adicionar
      </v-btn>
    </div>
  </v-menu>
</template>

<style scoped>
.menu__content {
  background-color: white;
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  data () {
    return {
      sortingColumnsValues: [
        { text: 'Número guia prestador', value: 'numeroGuiaPrestador' },
        { text: 'Número guia operadora', value: 'numeroGuiaOperadora' },
        { text: 'Senha', value: 'senha' },
        { text: 'Nome beneficiário', value: 'nomeBeneficiario' },
        { text: 'Número carteira', value: 'numeroCarteira' },
        { text: 'Valor total', value: 'valorTotal' }
      ],
      sortingOrderValues: [
        { text: 'Crescente', value: 'asc' },
        { text: 'Decrescente', value: 'desc' }
      ]
    }
  },
  computed: {
    ...mapState('conciliacao', ['faturamentoGuiasSorting']),
    count () {
      return this.faturamentoGuiasSorting
        .filter(sort => Boolean(sort.value))
        .length
    },
    showBadge () {
      return this.count > 0
    }
  },
  methods: {
    addNewSort () {
      this.$store.dispatch('conciliacao/addFaturamentoGuiasSortingValue', { value: null, direction: 'asc' })
    },
    removeSort (index) {
      this.$store.dispatch('conciliacao/removeFaturamentoGuiasSortingValueByIndex', index)
    },
    updateSortValue (index, newValue) {
      this.$store.dispatch('conciliacao/updateFaturamentoGuiasSortingValue', { index, value: newValue })
    },
    updateSortDirection (index, newDirection) {
      this.$store.dispatch('conciliacao/updateFaturamentoGuiasSortingDirection', { index, direction: newDirection })
    }
  }
}
</script>
